import qrcode from "qrcode-generator";
import { addDays, addMonths } from "date-fns";
import { formatPrecisaoFloat } from "../utils";
import { Icon, Tooltip } from "../components";
export const getListaPagamentoPadrao = (configuracao, meioPagamentoList) => {
  const idsPagamentos =
    configuracao?.meioPagamentosPadroesConfiguracoes?.map((pagamento) => ({
      id: pagamento.meioPa,
    })) || [];
  return meioPagamentoList.filter((item) =>
    idsPagamentos.some((idPagamento) => item.id === idPagamento.id),
  );
};

export const getAspectRatioLogoEmpresa = () => {
  const img = document.getElementById("logo-empresa");
  const aspectRatio = (img?.naturalWidth || 1) / (img?.naturalHeight || 1);
  return aspectRatio <= 1.5 ? 100 : 20;
};

export const getQRCodeNfce = (qrCode) => {
  const qr = qrcode(0, "L");
  qr.addData(qrCode || "");
  qr.make();
  return qr.createDataURL(4);
};

const subtotalItem = (item) =>
  parseFloat(
    item.subtotal || item.quantidade * (item.valorUnitario || item.valor),
  );

export function tabProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export function verificarNotasEmitidasHoje(notas, operacaoFiscalId) {
  const notasHoje = notas.filter(
    (item) => item.operacaoFiscalId === operacaoFiscalId,
  );
  return notasHoje.length > 0;
}

export function getIndexItemMaisCaro(lista) {
  return lista.reduce(
    (maxIndex, currentItem, currentIndex, array) =>
      subtotalItem(currentItem) > subtotalItem(array[maxIndex])
        ? currentIndex
        : maxIndex,
    0,
  );
}

export function formatProdutosTotalizadores(
  name,
  nfSaidaItens,
  valueInputReal,
  totalNota,
) {
  const valueInput = parseFloat(valueInputReal || 0);
  let listaAtualizada = nfSaidaItens.map((item) => {
    const valorProporcional =
      formatPrecisaoFloat((subtotalItem(item) * 100) / totalNota) / 100;
    return {
      ...item,
      [name]:
        valueInput > 0
          ? formatPrecisaoFloat(valorProporcional * valueInput)
          : 0,
    };
  });
  ajustarDiferenca(name, valueInput, listaAtualizada);
  return listaAtualizada;
}

export function totalItensLista(listaNfSaidaProdutos) {
  if (listaNfSaidaProdutos?.length) {
    const total = listaNfSaidaProdutos.reduce(
      (prevVal, elem) => prevVal + subtotalItem(elem),
      0,
    );
    return total;
  }
}

export function totalVenda(nfSaida, nfSaidaItens, calculoTotalizadores) {
  const freteNota =
    nfSaida?.freteCompoeNota === true ? parseFloat(nfSaida?.frete ?? 0) : 0;
  const subtotalProdutos = totalItensLista(nfSaidaItens);
  const subtotalDesconto = calculaSubtotalParaChave(
    nfSaidaItens,
    calculoTotalizadores,
    "desconto",
  );
  const subtotalAcrescimo = calculaSubtotalParaChave(
    nfSaidaItens,
    calculoTotalizadores,
    "acrescimo",
  );
  const subtotalDespesas = calculaSubtotalParaChave(
    nfSaidaItens,
    calculoTotalizadores,
    "despesas",
  );
  const totalVenda =
    (subtotalProdutos || 0) -
    (subtotalDesconto || 0) +
    (subtotalAcrescimo || 0) +
    (subtotalDespesas || 0) +
    (freteNota || 0);
  return parseFloat(totalVenda.toFixed(2));
}

export function calculaSubtotalParaChave(lista, tipoOperacao, chave) {
  if (lista?.length > 0) {
    const valorCalculado = lista.reduce((acumulador, objetoAtual) => {
      return acumulador + parseFloat(objetoAtual[chave] ?? 0);
    }, 0);
    return tipoOperacao !== chave ? valorCalculado : 0;
  }
}

export function totalPagamentos(nfSaidaPagamentos) {
  if (nfSaidaPagamentos?.length) {
    const total = nfSaidaPagamentos.reduce(
      (prevVal, elem) => prevVal + parseFloat(elem.valorTitulo.toFixed(2)),
      0,
    );
    return parseFloat(total.toFixed(2));
  }
}

export function verificaBaixaAutomatica(nfSaida, meioPagamentoList) {
  const meioPagamentoIds = [
    ...new Set(nfSaida.nfSaidaPagamentos.map((item) => item.meioPagamentoId)),
  ];
  return meioPagamentoList
    .filter((item) => item.baixaAutomatica)
    .some((item) => meioPagamentoIds.includes(item.id));
}

export function mapearEndereco(endereco) {
  return {
    ...endereco,
    cidade: endereco.cidade.nome,
    codigoIbge: endereco.cidade.codigoIbge,
    estado: endereco.cidade.estado?.sigla,
  };
}

export function mapearEnderecos(enderecos) {
  return enderecos.map((endereco) => mapearEndereco(endereco));
}

export function encontrarEstado(estados, estadoId) {
  if (estados.length) {
    return estados.find((estado) => estado.id === estadoId)?.sigla;
  }
  return "";
}

export function encontrarEnderecoPadrao(enderecos) {
  return enderecos.find((endereco) => endereco.padrao === true);
}

export function calcularPrecoProduto(
  produto,
  preco,
  tabelaPrecoCliente,
  nfSaidaCondicaoPagamento,
) {
  if (
    tabelaPrecoCliente?.length > 0 &&
    nfSaidaCondicaoPagamento === tabelaPrecoCliente.condicaoPagamentoId
  ) {
    if (tabelaPrecoCliente.tipoTabela === "Por produto") {
      const tabelaPrecoProduto = tabelaPrecoCliente.tabelaPrecoProdutos.find(
        (item) => item.produtoId === produto.id,
      );
      if (tabelaPrecoProduto) return tabelaPrecoProduto.precoTabela;
      return preco;
    }
    if (tabelaPrecoCliente.aplicarDescontoEm === "Percentual") {
      return preco - preco * (tabelaPrecoCliente.descontoTabela / 100);
    }
    return preco - tabelaPrecoCliente.descontoTabela;
  }
  return preco;
}

export function parcelaData(indice, data, intervaloDias) {
  const dias = indice * (intervaloDias ?? 1);
  const meses = Math.floor(dias / 30);
  const diasRestantes = dias % 30;
  const dataAtualizada = addMonths(new Date(data), meses);
  const dataFinal = addDays(dataAtualizada, diasRestantes);
  return dataFinal;
}

export function csoValueFormat(csoSimplesList, produto) {
  if (csoSimplesList) {
    const objeto = csoSimplesList?.find(
      (objeto) => objeto?.codigo === produto?.tributosIcmsCsosn,
    );
    return objeto ? `${objeto.codigo} - ${objeto.descricao}` : "";
  }
}

export function compararPagamentosTotalNfSaida(nfSaida) {
  return nfSaida?.totalVenda - nfSaida?.totalPagamentos > 0;
}

export function GeraCodigoNumerico(dataEmissao) {
  const date = new Date(
    dataEmissao.getFullYear(),
    dataEmissao.getMonth(),
    dataEmissao.getDate(),
    dataEmissao.getHours(),
    dataEmissao.getMinutes(),
    dataEmissao.getSeconds(),
    dataEmissao.getMilliseconds(),
  );
  const utcMilliseconds = date.getTime();
  const codigo =
    utcMilliseconds.toString().slice(4, 10) +
    utcMilliseconds.toString().slice(16);
  return codigo;
}

export function Calculo_DV11(strNumero) {
  if (!strNumero) {
    return "";
  }
  let total = 0;
  let weight = 2;
  for (let i = strNumero.length - 1; i >= 0; i--) {
    const digit = parseInt(strNumero[i], 10);
    total += digit * weight;
    weight = (weight + 1) % 9;
  }
  const remainder = total % 11;
  return remainder === 0 || remainder === 1 ? "0" : (11 - remainder).toString();
}

export function formatProdutosTotalizadoresDto(
  nfSaidaItens,
  totalNota,
  nfSaida,
) {
  const { acrescimo = 0, despesas = 0, desconto = 0 } = nfSaida;
  let listaAtualizada = nfSaidaItens.map((item) => {
    const valorProporcional =
      formatPrecisaoFloat((subtotalItem(item) * 100) / totalNota) / 100;
    const novosValores = {
      acrescimo: formatPrecisaoFloat(valorProporcional * acrescimo),
      despesas: formatPrecisaoFloat(valorProporcional * despesas),
      desconto: formatPrecisaoFloat(valorProporcional * desconto),
    };
    return {
      ...item,
      ...novosValores,
    };
  });
  ajustarDiferenca("acrescimo", acrescimo, listaAtualizada);
  ajustarDiferenca("despesas", despesas, listaAtualizada);
  ajustarDiferenca("desconto", desconto, listaAtualizada);

  return listaAtualizada;
}

function ajustarDiferenca(key, valorTotal, listaAtualizada) {
  const subtotalLista = calculaSubtotalParaChave(listaAtualizada, "", key);
  const subtotal = parseFloat(subtotalLista.toFixed(2));
  if (valorTotal !== subtotal && valorTotal > 0 && subtotal > 0) {
    const indiceItemMaisCaro = getIndexItemMaisCaro(listaAtualizada);
    const diferenca = valorTotal - formatPrecisaoFloat(subtotal);
    listaAtualizada[indiceItemMaisCaro][key] += diferenca;
  }
}

export function calculoDesconto(itens, nfSaida, porCemParaDecimal = true) {
  const total =
    totalItensLista(itens) +
    parseFloat(nfSaida?.acrescimo ?? 0) +
    parseFloat(nfSaida?.despesas ?? 0);

  let resultado;
  if (porCemParaDecimal) {
    const descontoPorcentagem = parseFloat(nfSaida?.descontoPorcentagem ?? 0);
    resultado = (descontoPorcentagem / 100) * total;
    resultado = formatPrecisaoFloat(resultado, 3);
  } else {
    const desconto = parseFloat(nfSaida?.desconto ?? 0);
    resultado = (desconto / formatPrecisaoFloat(total)) * 100;
    resultado = formatPrecisaoFloat(resultado, 3);
  }
  return resultado || 0;
}

export function isProdutoFracionavel(produto) {
  return (
    produto?.fracionavel === true ||
    produto?.lerPesoPorBalanca === "Ler peso da balança"
  );
}

export function normalizarQuantidade(produto, quantidade) {
  const quantidadeNumerica = Number(quantidade);
  if (!Number.isFinite(quantidadeNumerica) || quantidadeNumerica <= 0) {
    return 1;
  }
  if (isProdutoFracionavel(produto)) {
    return quantidadeNumerica;
  }
  return Math.max(1, Math.trunc(quantidadeNumerica));
}

export function montarItem(
  produto,
  produtoResultante,
  quantidadeFind,
  insertItem = true,
) {
  const quantidade = normalizarQuantidade(
    produtoResultante,
    (quantidadeFind || produtoResultante?.quantidade) ?? 1,
  );
  const totalItem =
    produtoResultante.totalItem ?? produtoResultante.precoVenda * quantidade;
  let itemTemp = {
    ...produtoResultante,
    quantidade,
    unidade: produtoResultante.unidadeProduto
      ? produtoResultante.unidadeProduto?.codigo
      : "",
    estoqueAtual: produtoResultante?.estoqueProduto?.estoque
      ? `${produtoResultante.estoqueProduto.estoque}`
      : 0,
    produtoId: produtoResultante?.produtoId || produtoResultante.id,
    descricao: produtoResultante?.descricao || "",
    codigo: produtoResultante?.codigo,
    ncm: produtoResultante?.ncmCodigo,
    cestId: produtoResultante?.cestId,
    valor: calcularPrecoProduto(
      produtoResultante,
      produtoResultante?.precoVenda,
      [],
      null,
    ),
    totalItem,
  };
  if (insertItem) {
    itemTemp = { ...produto, ...itemTemp };
  }
  let resultItem = { ...itemTemp };
  return resultItem;
}

export function obterIconeStatus(status) {
  switch (status) {
    case "PENDENTE":
      return (
        <Tooltip title="Pendente" arrow placement="right">
          <Icon>
            <i
              className="ph-fill ph-circle"
              style={{ color: "#EA9D2B", fontSize: 18 }}
            ></i>
          </Icon>
        </Tooltip>
      );
    case "ENVIADA":
      return (
        <Tooltip title="Enviada" arrow placement="right">
          <Icon>
            <i
              className="ph-fill ph-circle"
              style={{ color: "#4FBB53", fontSize: 18 }}
            ></i>
          </Icon>
        </Tooltip>
      );
    case "CONTINGENCIA":
      return (
        <Tooltip title="Em Contigência" arrow placement="right">
          <Icon>
            <i
              className="ph-fill ph-circle"
              style={{ color: "#BFBFBF", fontSize: 18 }}
            ></i>
          </Icon>
        </Tooltip>
      );
    case "CANCELADA":
      return (
        <Tooltip title="Cancelada" arrow placement="right">
          <Icon>
            <i
              className="ph-fill ph-circle"
              style={{ color: "#DC3545", fontSize: 18 }}
            ></i>
          </Icon>
        </Tooltip>
      );
    case "DENEGADA":
      return (
        <Tooltip title="Denegada" arrow placement="right">
          <Icon>
            <i
              className="ph-fill ph-circle"
              style={{ color: "#70309F", fontSize: 18 }}
            ></i>
          </Icon>
        </Tooltip>
      );
    case "EM PROCESSAMENTO":
      return (
        <Tooltip title="Em Processamento" arrow placement="right">
          <Icon>
            <i
              className="ph-fill ph-circle"
              style={{ color: "#A0522D", fontSize: 18 }}
            ></i>
          </Icon>
        </Tooltip>
      );
    case "FATURADA":
      return (
        <Tooltip title="Faturada" arrow placement="right">
          <Icon>
            <i
              className="ph-fill ph-circle"
              style={{ color: "#004780", fontSize: 18 }}
            ></i>
          </Icon>
        </Tooltip>
      );
  }
}
